module.exports = "/packs/images/pages/venues/play_desktop~4258dfe4b75f9c1bf7046e7d2db2a137.jpg";